if (window.location.pathname.includes('/en/') || window.location.pathname == '/en' || window.location.pathname.includes('/en-global/') || window.location.pathname == '/en-global') {
    setInterval(function hideOptionsToBuyAroundTheWorld() {
        var queries = [
            'div#shopify-section-barra > *',
            '.price--large',
            'variant-radios',
            '.product-form__input.product-form__quantity',
            'product-form.product-form',
            '.card-information>.price',
            '.para_presentear',
            'a[href="/products/felisa-special-journey"]',
            'a[href="/en/products/felisa-special-journey"]',
            '.list-menu a[href="/en/pages/onde-comprar"]',
            '.list-menu a[href="/en/products/travel-set"]',
            '.footer-block__newsletter',
            'form-embed#app-embed-container-12974',
            'a.whatsapp_float',
            '.grid__item[data-product="felisa-special-journey"]',
            '.grid__item[data-product="travel-set"]',
            '.image-with-text[data-ref="special-journey"]',
            '.image-with-text[data-ref="travel-kit"]',
            '.galeria_foto .tooltip-container'
        ];
        queries.forEach(function (query) {
            document.querySelectorAll(query + ':not(.hide)').forEach(function (item) {
                item.style.display = "none";
                item.classList.add('hide');
            });
        });
    }, 250);
}

document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('.scroll-animate');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            } else {
                entry.target.classList.remove('visible');
            }
        });
    }, {
        threshold: 0.1
    });

    images.forEach(image => {
        observer.observe(image);
    });
});

/* language selector */
var btns = document.querySelectorAll('.disclosure__button.localization-form__select');
btns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wrapper = this.parentElement.querySelector('.disclosure__list-wrapper');
        if (!wrapper) return null;
        if (wrapper.hidden) wrapper.removeAttribute("hidden");
        else wrapper.hidden = true;
    });
});

var languageForms = document.querySelectorAll('form#FooterLanguageForm');
languageForms.forEach(function (languageForm) {
    var linksLanguage = languageForm.querySelectorAll('#FooterLanguageList .disclosure__link');
    linksLanguage.forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            
            var selectedLang = this.dataset.value; // Obtém o idioma selecionado
            
            // Mapeamento de idiomas para URLs corretas
            var languageURLs = {
                "pt-BR": "https://felisa.com.br", // Loja BR
                "en": "https://felisafragrances.com" // Loja Global
            };

            if (languageURLs[selectedLang]) {
                window.location.href = languageURLs[selectedLang]; // Redireciona
            }
        });
    });
});

// Limite de 3 letras para campo
document.addEventListener('DOMContentLoaded', function () {
    const textArea = document.querySelector('.para_presentear #CartDrawer-Product-Note.three-letter-max');
    if (textArea) {
        textArea.addEventListener('input', function () {
            if (this.value.length > 3) {
                this.value = this.value.slice(0, 3);
            }
        });
    }
});

// Toggle menu
function customToggleMenu(menuItem) {
    var menu = menuItem.parentElement.querySelector('.menu-drawer__menu-sublist');
    if (!menu) return null;
    if (menu.style.display == 'block') {
        menu.style.display = 'none';
        menuItem.classList.remove('active');
    } else {
        menu.style.display = 'block';
        menuItem.classList.add('active');
    }
}
var menuItems = document.querySelectorAll('.menu-drawer__menu-item-header');
menuItems.forEach(function (menuItem) {
    menuItem.addEventListener('click', function (e) {
        customToggleMenu(this);
    });
});
